import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import ServisMarkup from '../entities/flight/servisMarkup'

interface ServisMarkupState extends ListState<ServisMarkup> {
    servisMarkup: ServisMarkup,
    editServisMarkup: ServisMarkup,
}

class ServisMarkupMutations extends ListMutations<ServisMarkup> {
}

class ServisMarkupModule extends ListModule<ServisMarkupState, any, ServisMarkup> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<ServisMarkup>(),
        loading: false,
        editServisMarkup: new ServisMarkup(),
        selectServisMarkup: new ServisMarkup(),
    }

    actions = {
        async getMetaSearchAgencies(context: ActionContext<ServisMarkupState, any>) {
            context.state.loading = true;
            let response = await Ajax.get('/api/services/app/Flight/GetMetaSearchAgencies');
            context.state.loading = false;
            return response.data.result;
        },

        async getWebServiceDefinitions(context: ActionContext<ServisMarkupState, any>) {
            context.state.loading = true;
            let response = await Ajax.get('/api/services/app/Flight/GetWebServiceDefinitions');
            context.state.loading = false;
            return response.data.result;
        },

        async addWebServiceMarkup(context: ActionContext<ServisMarkupState, any>, payload: any) {
            await Ajax.post('/api/services/app/Flight/AddWebServiceMarkup', payload.data);
        },

     

        async saveServisMarkup(context: ActionContext<ServisMarkupState, any>, payload: any) {
            let response = await Ajax.post(
                '/api/services/app/Flight/SaveWebServiceMarkup',
                payload.data
            );
        },

        async getServisMarkups(context: ActionContext<ServisMarkupState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.get('/api/services/app/Flight/GetWebServiceMarkups');
            console.log(response);
            context.state.loading = false;
            let page = response.data.result as PageResult<ServisMarkup>;

            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },

        async deleteServisMarkup(context: ActionContext<ServisMarkupState, any>, payload: any) {
            await Ajax.delete(
                '/api/services/app/Flight/DeleteWebServiceMarkup?id=' + payload.payload
            );
        },
    };

    mutations = {
        setCurrentPage(state: ServisMarkupState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ServisMarkupState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const servisMarkupModule = new ServisMarkupModule();
export default servisMarkupModule; 